<style>
  :host {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0;
  }

  p {
    margin: 0;
  }

  .spacer {
    flex: 1;
  }

  .toolbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    display: flex;
    align-items: center;
    background-color: #1976d2;
    color: white;
    font-weight: 600;
  }

  .toolbar img {
    margin: 0 16px;
  }

  .toolbar #twitter-logo {
    height: 40px;
    margin: 0 8px;
  }

  .toolbar #youtube-logo {
    height: 40px;
    margin: 0 16px;
  }

  .toolbar #twitter-logo:hover,
  .toolbar #youtube-logo:hover {
    opacity: 0.8;
  }

  .content {
    display: flex;
    margin: 82px auto 32px;
    padding: 0 16px;
    max-width: 960px;
    flex-direction: column;
    align-items: center;
  }

  svg.material-icons {
    height: 24px;
    width: auto;
  }

  svg.material-icons:not(:last-child) {
    margin-right: 8px;
  }

  .card svg.material-icons path {
    fill: #888;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 16px;
  }

  .card {
    all: unset;
    border-radius: 4px;
    border: 1px solid #eee;
    background-color: #fafafa;
    height: 40px;
    width: 200px;
    margin: 0 8px 16px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    line-height: 24px;
  }

  .card-container .card:not(:last-child) {
    margin-right: 0;
  }

  .card.card-small {
    height: 16px;
    width: 168px;
  }

  .card-container .card:not(.highlight-card) {
    cursor: pointer;
  }

  .card-container .card:not(.highlight-card):hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(0, 0, 0, 0.35);
  }

  .card-container .card:not(.highlight-card):hover .material-icons path {
    fill: rgb(105, 103, 103);
  }

  .card.highlight-card {
    background-color: #1976d2;
    color: white;
    font-weight: 600;
    border: none;
    width: auto;
    min-width: 30%;
    position: relative;
  }

  .card.card.highlight-card span {
    margin-left: 60px;
  }

  svg#rocket {
    width: 80px;
    position: absolute;
    left: -10px;
    top: -24px;
  }

  svg#rocket-smoke {
    height: calc(100vh - 95px);
    position: absolute;
    top: 10px;
    right: 180px;
    z-index: -10;
  }

  a,
  a:visited,
  a:hover {
    color: #1976d2;
    text-decoration: none;
  }

  a:hover {
    color: #125699;
  }

  .terminal {
    position: relative;
    width: 100%;
    max-width: 600px;
    border-radius: 6px;
    padding-top: 45px;
    margin-top: 8px;
    overflow: hidden;
    background-color: rgb(15, 15, 16);
  }

  .terminal::before {
    content: "\2022 \2022 \2022";
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    background: rgb(58, 58, 58);
    color: #c2c3c4;
    width: 100%;
    font-size: 2rem;
    line-height: 0;
    padding: 14px 0;
    text-indent: 4px;
  }

  .terminal pre {
    font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace;
    color: white;
    padding: 0 1rem 1rem;
    margin: 0;
  }

  .circle-link {
    height: 40px;
    width: 40px;
    border-radius: 40px;
    margin: 8px;
    background-color: white;
    border: 1px solid #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: 1s ease-out;
  }

  .circle-link:hover {
    transform: translateY(-0.25rem);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }

  footer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    line-height: 20px;
  }

  footer a {
    display: flex;
    align-items: center;
  }

  .github-star-badge {
    color: #24292e;
    display: flex;
    align-items: center;
    font-size: 12px;
    padding: 3px 10px;
    border: 1px solid rgba(27,31,35,.2);
    border-radius: 3px;
    background-image: linear-gradient(-180deg,#fafbfc,#eff3f6 90%);
    margin-left: 4px;
    font-weight: 600;
  }

  .github-star-badge:hover {
    background-image: linear-gradient(-180deg,#f0f3f6,#e6ebf1 90%);
    border-color: rgba(27,31,35,.35);
    background-position: -.5em;
  }

  .github-star-badge .material-icons {
    height: 16px;
    width: 16px;
    margin-right: 4px;
  }

  svg#clouds {
    position: fixed;
    bottom: -160px;
    left: -230px;
    z-index: -10;
    width: 1920px;
  }

  /* Responsive Styles */
  @media screen and (max-width: 767px) {
    .card-container > *:not(.circle-link) ,
    .terminal {
      width: 100%;
    }

    .card:not(.highlight-card) {
      height: 16px;
      margin: 8px 0;
    }

    .card.highlight-card span {
      margin-left: 72px;
    }

    svg#rocket-smoke {
      right: 120px;
      transform: rotate(-5deg);
    }
  }

  @media screen and (max-width: 875px) {
    svg#rocket-smoke {
      display: none;
      visibility: hidden;
    }
  }
</style>
 































<!-- <app-header></app-header> -->
 

 <div class="hero-section">
      <div class="hero-content">

        <!-- Guest: not logged in -->
        <ng-container *ngIf="!isLoggedIn">
          <h1>Find Reliable Local Services</h1>
          <p>Connect with trusted tradespeople — electricians, plumbers, carpenters, and more — in your area.</p>
          <div class="hero-actions">
            <button class="btn-login" (click)="login()">
              <span class="btn-login-icon">👤</span> Sign In
            </button>
            <button class="btn-primary" (click)="browseServices()">Browse Services</button>
            <button class="btn-secondary" (click)="becomeProvider()">Become a Provider</button>
          </div>
          <div class="hero-secondary-action">
            New here? <a (click)="login()" class="hero-link">Create a free account</a>
          </div>
        </ng-container>

        <!-- Customer: logged in as customer -->
        <ng-container *ngIf="isCustomer">
          <h1>Welcome back, {{ currentUser?.firstName || currentUser?.username }}!</h1>
          <p>Browse services from trusted local tradespeople, manage your bookings, and keep your home running smoothly.</p>
          <div class="hero-actions">
            <button class="btn-primary" (click)="browseServices()">Browse Services</button>
            <button class="btn-secondary" (click)="goToDashboard()">My Dashboard</button>
          </div>
          <div class="hero-secondary-action">
            Are you a tradesperson? <a (click)="becomeProvider()" class="hero-link">Become a Provider</a>
          </div>
        </ng-container>

        <!-- Provider: logged in as provider -->
        <ng-container *ngIf="isProvider">
          <h1>Welcome back, {{ currentUser?.firstName || currentUser?.username }}!</h1>
          <p>Manage your services, view bookings, and grow your business — all in one place.</p>
          <div class="hero-actions">
            <button class="btn-primary" (click)="goToDashboard()">My Dashboard</button>
            <button class="btn-secondary" (click)="browseServices()">Browse Marketplace</button>
          </div>
        </ng-container>

      </div>
    </div>
    
    <div class="features-section">
      <h2>Why Choose ServiceHub?</h2>
      <div class="container">
        
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">🔧</div>
            <h3>Recurring Services</h3>
            <p>Set up weekly, monthly, or seasonal service schedules that work for you.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">💳</div>
            <h3>Secure Payments</h3>
            <p>Automatic billing and secure payment processing. No cash needed.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">⭐</div>
            <h3>Trusted Providers</h3>
            <p>All service providers are vetted and rated by real customers.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">📱</div>
            <h3>Easy Scheduling</h3>
            <p>Book, reschedule, or cancel services with just a few clicks.</p>
          </div>
        </div>
      </div>
    </div>













<!-- 
  <app-bottomcards></app-bottomcards> -->
  <app-plans></app-plans>
